module.exports = "pegasus_template/assets/background-patterns/theme4_theme.gif";